const changeStateContinueButton = () => {
  let $signature_checkbox = $('[data-cart-summary].hidden--mobile [data-shipping-signature]');
  let $checkout_button = $('[data-cart-summary].hidden--mobile [data-cart-checkout]');

  if (window.theme.breakpoints.current === 'mobile' || window.theme.breakpoints.current === 'tablet') {
    $signature_checkbox = $('[data-cart-summary].hidden--desktop [data-shipping-signature]');
    $checkout_button = $('[data-cart-summary].hidden--desktop [data-cart-checkout]');
  }

  if ($signature_checkbox.is(':checked')) {
    $checkout_button.removeClass('disabled');
  } else {
    $checkout_button.addClass('disabled');
  }
};

export default () => {
  if (!$('[data-shipping-signature]').length) {
    return;
  }

  // Due to code duplication
  $('[data-cart-summary="desktop"] [data-shipping-signature]').attr('id', 'shipping-signature-desktop');
  $('[data-cart-summary="mobile"] [data-shipping-signature]').attr('id', 'shipping-signature-mobile');
  $('[data-cart-summary="desktop"] .cart-summary__signature label').attr('for', 'shipping-signature-desktop');
  $('[data-cart-summary="mobile"] .cart-summary__signature label').attr('for', 'shipping-signature-mobile');

  changeStateContinueButton();

  $(document).on('click touchend', '[data-cart-checkout]', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const $item = $(e.currentTarget);

    if ($item.hasClass('disabled')) {
      return;
    }

    window.location.href = $item.attr('href');
  });

  $(document).on('change', '[data-shipping-signature]', () => {
    changeStateContinueButton();
  });
};
